import { focusItems } from '@/mocks/home';

export default function FocusSection() {
  return (
    <section id="carousel" className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-900 mb-2">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-600">精选赛事专题，深度聚焦不容错过的精彩</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {focusItems.slice(0, 3).map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group block rounded-xl overflow-hidden bg-background-50 hover:bg-background-200/50 transition-colors cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 right-3">
                  <span className="px-2.5 py-1 rounded-full text-[11px] font-medium bg-accent-500 text-white whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {focusItems.slice(3, 5).map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group flex flex-col sm:flex-row rounded-xl overflow-hidden bg-background-50 hover:bg-background-200/50 transition-colors cursor-pointer"
            >
              <div className="relative w-full sm:w-48 md:w-56 aspect-[16/10] sm:aspect-auto flex-shrink-0 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 right-3">
                  <span className="px-2.5 py-1 rounded-full text-[11px] font-medium bg-accent-500 text-white whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex flex-col justify-center flex-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}